export default __webpack_public_path__ + "static/improve-lives-95c0107dae95efb524f404116372ab9e.jpg";